module.exports = __webpack_public_path__ + "images/scatter-chart-icon.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/scatter-chart-icon.png
// module id = 204
// module chunks = 0